var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-panel',{attrs:{"title":_vm.title,"titleIcon":_vm.titleIcon,"id":_vm.id},on:{"clickMore":_vm.handleClickMore}},[_c('div',{staticClass:"article-list"},_vm._l((_vm.articleList),function(item){return _c('ArticleItem',{key:item.fileId,attrs:{"articleInfo":item,"isPC":_vm.isPC}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }